import React, { useEffect, useState } from 'react';
import './textarea.scss';

export const Textarea = ({
  onClick,
  value,
  onChange,
  placeholder = 'Start typing your comments...',
  showBtn = true,
  height = 'inherit',
  marginBottom = '4rem',
  error = false,
  errorText = '',
  active = false,
  maxLimit = 500,
  showMaxLimit = true,
  onKeyDown,
  autoFocus = false,
  buttonText = 'Add',
  ...props
}) => {
  const [inputVal, setInputVal] = useState(value);

  useEffect(() => {
    setInputVal(value);
  }, [value]);

  const handleChange = (event) => {
    const value = event.target.value;
    setInputVal(value);
    onChange(event);
  };

  const onSubmit = () => {
    setInputVal('');
    onClick();
  };

  return (
    <div className='textarea'>
      <textarea
        className={`medium ${errorText.length ? 'errorBox' : ''}`}
        style={{
          border: !showBtn ? '0.5px solid #CFCFCF' : 'none',
          borderRadius: 8,
          padding: !showBtn ? '1rem' : 0,
          height: height,
          marginBottom: showBtn ? marginBottom : '0',
        }}
        value={inputVal}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLimit}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
        {...props}
        data-dd-privacy='mask'
      />
      {showMaxLimit && (
        <p className='light note small '>
          Maximum characters limit : {maxLimit}
        </p>
      )}
      {showBtn && (
        <button
          onClick={onSubmit}
          className={`medium ${active ? 'active' : ''} `}
        >
          {buttonText}
        </button>
      )}
      {error && (
        <p
          style={{
            color: '#D02A38',
          }}
        >
          {errorText}
        </p>
      )}
    </div>
  );
};
